import type { CaptchaPublicConfig } from '@/lib/captcha'
import { CURRENT_CLIENT } from '@/constants/index'

export type CaptchaWidgetConfig = {
  size?: string
  theme?: string
}

export type CaptchaClientConfig = {
  enabled?: boolean
  provider?: string
  actions?: Record<string, boolean>
  widget?: CaptchaWidgetConfig
}

export function getClientCaptchaConfig(): CaptchaClientConfig {
  const auth = (CURRENT_CLIENT as { auth?: { captcha?: CaptchaClientConfig } }).auth
  return (auth?.captcha ?? {}) as CaptchaClientConfig
}

export function mergeCaptchaWidgetDefaults(config: CaptchaPublicConfig): CaptchaPublicConfig {
  const clientWidget = getClientCaptchaConfig().widget ?? {}
  return {
    ...config,
    widget: {
      size: config.widget?.size ?? clientWidget.size ?? 'normal',
      theme: config.widget?.theme ?? clientWidget.theme ?? 'light',
    },
  }
}

export function clientCaptchaActionExpected(action: string): boolean {
  const client = getClientCaptchaConfig()
  if (!client.enabled) return false
  return Boolean(client.actions?.[action] ?? true)
}
